import { useEffect } from "react";

export const usePageTitle = (title, deps = []) => {
  useEffect(() => {
    if (title) {
        document.title = title + ' - ' + 'Configurator';
    }
  }, [title, ...deps]);
}